import React from 'react';
import * as XLSX from 'xlsx';
import _ from 'lodash';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';

export default function ExcelSheetGenerator({
  dataSets,
  sheetName = 'Material',
  columnList = [],
  columnDataList = [],
  spreadedColumn = '',
  type = '',
}) {
  let spreadedDataSet = [];
  if (spreadedColumn !== '') {
    _.map(dataSets, (eachData) => {
      _.map(eachData?.[spreadedColumn], (eachColumn) => {
        spreadedDataSet.push({ ...eachData, ...eachColumn });
      });
    });
  } else {
    spreadedDataSet = dataSets;
  }

  const dataSetWithIndex = _.map(spreadedDataSet, (eachData, index) => ({
    index: index + 1,
    ...eachData,
  }));

  const handleExport = () => {
    // เลือกรายการคอลัมน์ที่จะใช้
    const columns = type === 'excelDataAll' ? columnDataList : columnList;

    // Map ข้อมูลให้เป็นรูปแบบที่ xlsx ต้องการ โดยเลือกเฉพาะค่าตามคอลัมน์ที่กำหนด
    const dataForSheet = dataSetWithIndex.map((dataRow) => {
      const newRow = {};
      columns.forEach((col) => {
        // ใช้ _.get เพื่อเข้าถึงค่าใน object ที่ซ้อนกันได้อย่างปลอดภัย
        newRow[col.label] = _.get(dataRow, col.value);
      });
      return newRow;
    });

    // สร้าง worksheet และ workbook
    const ws = XLSX.utils.json_to_sheet(dataForSheet);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, sheetName);

    // บันทึกไฟล์และเริ่มการดาวน์โหลด
    XLSX.writeFile(wb, `${sheetName}-${dayjs().format('YYYYMMDD')}.xlsx`);
  };

  return (
    // Component นี้จะคืนค่าเป็นปุ่ม HTML ธรรมดา ที่เรียกใช้ฟังก์ชัน handleExport
    <button onClick={handleExport}>Export to Excel</button>
  );
}

ExcelSheetGenerator.propTypes = {
  dataSets: PropTypes.arrayOf(PropTypes.object),
  columnList: PropTypes.arrayOf(PropTypes.object),
  columnDataList: PropTypes.arrayOf(PropTypes.object),
  sheetName: PropTypes.string,
  spreadedColumn: PropTypes.string,
  type: PropTypes.string,
};
